<template>
    <svg :width="width" :height="width" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 14C3.12941 14 0 10.8706 0 7C0 3.12941 3.12941 0 7 0C10.8706 0 14 3.12941 14 7C14 10.8706 10.8706 14 7 14ZM7 0.823529C3.58235 0.823529 0.823529 3.58235 0.823529 7C0.823529 10.4176 3.58235 13.1765 7 13.1765C10.4176 13.1765 13.1765 10.4176 13.1765 7C13.1765 3.58235 10.4176 0.823529 7 0.823529Z" :fill="color"/>
    <path d="M3.29411 6.58824H10.7059V7.41177H3.29411V6.58824Z" :fill="color"/>
    <path d="M6.58824 3.29411H7.41177V10.7059H6.58824V3.29411Z" :fill="color"/>
    </svg>
</template>

<script>
export default {
  name: 'AddIcon',
  props: ['width','color']
}
</script>
